export const LINK_CARD_BEGIN = 'LINK_CARD_BEGIN';
export const LINK_CARD_SUCCESS = 'LINK_CARD_SUCCESS';
export const LINK_CARD_FAILURE = 'LINK_CARD_FAILURE';

const linkCardSuccess = () => ({
  type: LINK_CARD_SUCCESS,
  payload: null,
});

const linkCardBegin = () => ({
  type: LINK_CARD_BEGIN,
});

const linkCardFailure = (error) => ({
  type: LINK_CARD_FAILURE,
  error: error.message,
});

export const linkCard = () => (dispatch) => {
  dispatch(linkCardBegin());
  return fetch(`/api/cards/link`, {
    credentials: 'same-origin'
  })
  .then(response => handleErrors(response))
  .then(data => dispatch(linkCardSuccess(data)))
  .catch(err => {
    return dispatch(linkCardFailure(err));
  });
}

function handleErrors(response) {
  if (!response.ok) {
    return response.json().then(errorResponse => {
      if (response.status === 404) {
        throw new Error(response.detail || 'Deze pas werd niet gevonden.');
      } else if (response.status === 403) {
        throw new Error(response || 'U heeft geen toegang.');
      } else {
        throw new Error(response || 'Er is een fout opgetreden.');
      }
    }).catch(err => {
      throw err;
    });
  }
  return response.json();
}